import React from 'react';
import { Skeleton } from '@parsina/framework';
import { C } from '../../constants/theme.js';
import { SkeletonPage } from '../../components/common/skeletons.jsx';

// اعتبار — the loading shape of the LEDGER only.
//
// Everything above the ledger is real chrome while it loads: the balance hero
// draws its cached balance, `KpiCard` / `StatTiles` carry their own loading
// dash, the type filter and the group/date controls are operable. What the
// query fills is the list of transactions, so that is what skeletons — in the
// shape of `TransactionRow` (desktop: 34px icon tile, body + micro line,
// amount; 10px 16px padding) and `MobileTxnRow` (30px tile, 9px 12px
// padding), under a day-group caption strip, so the first row lands exactly
// where its placeholder was.

const Row = ({ i, mobile }) => (
  <div
    aria-hidden
    style={{
      display: 'flex', alignItems: 'center',
      gap: mobile ? '0.625rem' : 12,
      padding: mobile ? '0.5625rem 0.75rem' : '10px 16px',
      borderBottom: `1px solid ${C.border}`,
    }}
  >
    <Skeleton width={mobile ? 30 : 34} height={mobile ? 30 : 34} radius={9} />
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 5 }}>
      <Skeleton width={`${34 + ((i * 17) % 30)}%`} height={13} />
      <Skeleton width={`${22 + ((i * 11) % 24)}%`} height={10} />
    </div>
    <Skeleton width={64} height={14} />
  </div>
);

const GroupCaption = ({ mobile }) => (
  <div aria-hidden style={{ padding: mobile ? '0.3125rem 0.75rem' : '6px 16px', background: C.bg }}>
    <Skeleton width={96} height={11} />
  </div>
);

export const LedgerSkeleton = ({ label, mobile = false, rows = 5 }) => (
  <SkeletonPage label={label} data-testid="credits-ledger-skeleton">
    <GroupCaption mobile={mobile} />
    {Array.from({ length: rows }, (_, i) => <Row key={i} i={i} mobile={mobile} />)}
  </SkeletonPage>
);
